import { FiltersFieldIds } from '@epicuro-next/models/order-book';
import { FilterValue, OrderFilter } from 'graphql-api/baskets-api-interfaces';
import { pipe } from 'rxjs';

import {
  defaultAllDisplayName,
  defaultAllValue,
  DEFAULT_ORDER_BOOK_FILTERS_VALUES,
} from '../../constants';
import { isRegularFilter } from '../is-regular-filter/is-regular-filter';
import { mapFilterValuesToUi } from '../map-filter-values-to-ui/map-filter-values-to-ui';

export function mapFiltersToUi(filters: OrderFilter[]): OrderFilter[] {
  return filters
    .map((filter) => ({ ...filter, values: [...(filter.values ?? [])] }))
    .map(pipe(addRequiredValues, mapFilterValuesToUi));
}

export function addRequiredValues(
  filter: OrderFilter & { values: FilterValue[] },
) {
  let completeFilter = (
    DEFAULT_ORDER_BOOK_FILTERS_VALUES[filter.fieldId as FiltersFieldIds] ?? []
  )
    .filter(
      (defaultFilter) =>
        !filter.values.some(
          (presentFilter) => presentFilter.value === defaultFilter.value,
        ),
    )
    .reduce((filterToComplete, missedValue) => {
      return {
        ...filterToComplete,
        values: [
          ...filterToComplete.values,
          {
            value: missedValue.value,
            displayName: missedValue.displayName,
            count: 0,
          } as FilterValue,
        ],
      };
    }, filter);

  if (
    [
      FiltersFieldIds.OrderStatus,
      FiltersFieldIds.OrderType,
      FiltersFieldIds.Noos,
    ].includes(filter.fieldId as FiltersFieldIds)
  ) {
    // sort to be the same order and not jumping after reload filters
    completeFilter = {
      ...completeFilter,
      values: [...completeFilter.values].sort((a, b) =>
        b.value === defaultAllValue || a.value > b.value ? 1 : -1,
      ),
    };
  }

  if (
    !filter.isMultiple &&
    completeFilter.values.length &&
    isRegularFilter(filter) &&
    filter.fieldId !== FiltersFieldIds.DeliveryMonth
  ) {
    completeFilter.values.unshift({
      ...filter.values[0],
      displayName: defaultAllDisplayName,
      value: defaultAllValue,
      count: filter.values.reduce((res, val) => res + (val.count ?? 0), 0),
    });
  }

  return completeFilter;
}
